<template>
    <div class="site-info-container" >
        <b-card header-tag="header" v-if="site" :no-body="true" id="site-info">
            <b-card-header>
                <div class="title">{{site.name}}</div>
                <div class="reloaded-time">Reloaded on {{reloadStats}}
                    <span @click="emitAction('reloadData')" style="    margin-left: 8px;cursor:pointer">
                        <reload-icon class="icon-default reload"></reload-icon>
                    </span>
                </div>
            </b-card-header>
            <b-card-body class="d-flex">
                <div class="action-button-container">
                    <div class="action-button-wrapper start">
                        <b-button size="sm" variant="link" :href="site.URL" target="_blank" class="site-action-btn">
                            <span class="icon-cont">
                                <eye-icon class="icon-default eye-icon"></eye-icon>
                            </span>
                            <span>View site</span>
                        </b-button>
                    </div>
                    <div class="action-button-wrapper divide">
                        <b-button size="sm" class="site-action-btn" variant="link" target="_blank" :href="serverURL+'ajax.php?action=loadSite&siteID='+site.siteID">
                            <span class="icon-cont">
                                <open-admin-icon class="icon-default open-admin-icon"></open-admin-icon>
                            </span>
                            <span>open admin in new tab</span>
                        </b-button>
                    </div>
                    <div class="action-button-wrapper start">
                        <b-button size="sm" variant="link" class="site-action-btn" @click="emitAction('backupNow')">
                            <span class="icon-cont">
                                <backups-icon class="icon-default backups-icon"></backups-icon>
                            </span>
                            <span>Backup now</span>
                        </b-button>
                    </div>
                    <div class="action-button-wrapper divide">
                        <b-button size="sm" variant="link" class="site-action-btn" @click="emitAction('viewBackups')">
                            <span class="icon-cont">
                                <view-backups-icon class="icon-default view-backups-icon"></view-backups-icon>
                            </span>
                            <span>View backups</span>
                        </b-button>
                    </div>
                    <div class="action-button-wrapper start">
                        <b-button size="sm" variant="link" @click="emitAction('edit')" class="site-action-btn">
                            <span class="icon-cont">
                                <write-icon class="icon-default write-icon"></write-icon>
                            </span>
                            <span>Edit site details</span>
                        </b-button>
                    </div>
                    <div class="action-button-wrapper">
                        <b-button size="sm" variant="link" class="site-action-btn" @click="emitAction('maintenanceMode')">
                            <span class="icon-cont">
                                <maintanance-icon class="icon-default maintanance-icon"></maintanance-icon>
                            </span>
                            <span>maintanance mode</span>
                        </b-button>
                    </div>
                    <div class="action-button-wrapper">
                        <b-button size="sm" variant="link" class="site-action-btn" @click="emitAction('serverInfo')">
                            <span class="icon-cont">
                                <server-icon class="icon-default server-icon"></server-icon>
                            </span>
                            <span>server info</span>
                        </b-button>
                    </div>
                    <div class="action-button-wrapper" v-if="site.connectionStatus==='0'">
                        <b-button size="sm" variant="link" class="site-action-btn" @click="emitAction('reAddSite')">
                            <span class="icon-cont">
                                <server-icon class="icon-default server-icon"></server-icon>
                            </span>
                            <span>re-add site</span>
                        </b-button>
                    </div>
                    <div class="action-button-wrapper end">
                        <b-button size="sm" variant="link" class="site-action-btn danger" @click="emitAction('removeSite')">
                            <span class="icon-cont">
                                <delete-icon class="icon-default delete-icon"></delete-icon>
                            </span>
                            <span>remove site</span>
                        </b-button>
                    </div>
                </div>
                <div class="description-container">
                    <div class="site-info-desc-cont">
                        <div class="site-info-card divide">
                            <div class="site-info-desc-title">
                                Quick Status
                            </div>
                            <div class="site-info-desc-content">
                                <div class="update-wrapper">
                                    <wordpress-icon class="icon-default wordpress-icon"></wordpress-icon>
                                    <span class="desc-title">Wordpress</span>
                                    <span class="desc-count">
                                        {{site.WPVersion}}
                                    </span>
                                    <span class="desc-count highlight" v-if="updates['core']" style="width:120px">
                                        {{updates['core']}} update available
                                    </span>

                                </div>
                                <div class="update-wrapper">
                                    <plugin-icon class="icon-default plugin-icon"></plugin-icon>
                                    <span class="desc-title">Plugins</span>
                                    <span class="desc-count">
                                        <a :id="site.siteID+'pluginActive'">{{pluginsAndThemes.plugins.isActivated.length}} Active</a>
                                    </span>
                                    <span class="desc-count">
                                        <a :id="site.siteID+'pluginInstalled'">{{pluginsAndThemes.plugins.isInstalled.length}} Installed</a>
                                    </span>
                                    <span class="desc-count highlight">
                                        <a :id="site.siteID+'pluginUpdates'">{{updates['plugins'].length}} Updates </a>
                                    </span>
                                    <b-tooltip :target="site.siteID+'pluginInstalled'" placement="top"  boundary="window"  container="site-info">
                                        <div class="active" v-for="(plugin,index) in pluginsAndThemes.plugins.isInstalled" :key="index">
                                            {{plugin.name}} - {{plugin.old_version}}
                                        </div>
                                    </b-tooltip>
                                    <b-tooltip :target="site.siteID+'pluginActive'" placement="top" boundary="window" container="site-info">
                                        <div class="active" v-for="(plugin,index) in pluginsAndThemes.plugins.isActivated" :key="index">
                                            {{plugin.name}} -{{plugin.old_version}}
                                        </div>
                                    </b-tooltip>
                                    <b-tooltip :target="site.siteID+'pluginUpdates'" placement="top" boundary="window" container="site-info">
                                        <div class="active" v-for="(plugin,index) in updates.plugins" :key="index">
                                            {{plugin.name}} - {{plugin.old_version}} to {{plugin.new_version}}
                                        </div>
                                    </b-tooltip>

                                </div>
                                <div class="update-wrapper">
                                    <theme-icon class="icon-default theme-icon"></theme-icon>
                                    <span class="desc-title">Themes</span>
                                    <span class="desc-count">
                                        <a :id="site.siteID+'themeActive'" style="white-space: nowrap;">{{pluginsAndThemes.themes.isActivated.length}} Active</a>
                                    </span>
                                    <span class="desc-count">
                                        <a :id="site.siteID+'themeInstalled'" style="white-space: nowrap;">{{pluginsAndThemes.themes.isInstalled.length}} Installed</a>
                                    </span>
                                    <span class="desc-count highlight">
                                        <a :id="site.siteID+'themeUpdates'" style="white-space: nowrap;">{{updates['themes'].length}} Updates </a>
                                    </span>
                                    <b-tooltip :target="site.siteID+'themeInstalled'" placement="top" container="site-info" boundary="viewport">
                                        <div class="active" v-for="(plugin,index) in pluginsAndThemes.themes.isInstalled" :key="index">
                                            {{plugin.name}} - {{plugin.old_version}}
                                        </div>
                                    </b-tooltip>
                                    <b-tooltip :target="site.siteID+'themeActive'" placement="top" container="site-info" boundary="viewport">
                                        <div class="active" v-for="(plugin,index) in pluginsAndThemes.themes.isActivated" :key="index">
                                            {{plugin.name}} - {{plugin.old_version}}
                                        </div>
                                    </b-tooltip>
                                    <b-tooltip :target="site.siteID+'themeUpdates'" placement="top" container="site-info" boundary="viewport">
                                        <div class="active" v-for="(plugin,index) in updates.themes" :key="index">
                                            {{plugin.name}} -{{plugin.old_version}} to {{plugin.new_version}}
                                        </div>
                                    </b-tooltip>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="site-info-card divide">
                        <div class="site-info-desc-title">
                            Links
                            <span class="action-btns-cont">
                                <b-btn size="sm" variant="outline-secondary" @click="linksEdit">Add</b-btn>
                            </span>
                        </div>
                        <div class="site-info-desc-content">
                            <div class="desc-form" v-if="showLinksForm">
                                <b-form-textarea id="textarea1" v-model="newLinksText" placeholder="Use comma to add multiple links" :rows="3" :max-rows="6">
                                </b-form-textarea>
                                <div class="desc-form-footer text-right">
                                    <b-btn variant="flat" @click="showLinksForm=false">Cancel</b-btn>
                                    <b-btn size="sm" @click="saveLinks" variant="primary">Save</b-btn>
                                </div>
                            </div>
                            <div class="notes-content" v-else>
                                <div v-if="site.links">
                                    <div v-for="(link,index) in site.links" :key="index">
                                        <a :href="'http://'+link" target="_blank">
                                            http://{{link}}
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="site-info-card">
                        <div class="site-info-desc-title">
                            Notes
                            <span class="action-btns-cont">
                                <b-btn size="sm" variant="outline-secondary" @click="notesEdit">Add</b-btn>
                            </span>
                        </div>

                        <div class="site-info-desc-content">
                            <div class="desc-form" v-if="showNotesForm">
                                <b-form-textarea id="textarea1" v-model="newNotesText" placeholder="Enter something" :rows="3" :max-rows="6">
                                </b-form-textarea>
                                <div class="desc-form-footer text-right">
                                    <b-btn variant="flat" @click="showNotesForm=false">Cancel</b-btn>
                                    <b-btn size="sm" @click="saveNotes" variant="primary">Save</b-btn>
                                </div>
                            </div>
                            <div class="notes-content" v-else>
                                {{site.notes}}
                            </div>
                        </div>

                    </div>

                </div>

            </b-card-body>

        </b-card>

    </div>
</template>

<script>
import _ from 'lodash';

import EyeIcon from '../assets/eye.svg';
import MaintananceIcon from '../assets/maintanance.svg';
import ServerIcon from '../assets/server.svg';
import WriteIcon from '../assets/write.svg';
import ViewBackupsIcon from '../assets/viewbackups.svg';
import OpenAdminIcon from '../assets/openadmin.svg';
import BackupsIcon from '../assets/backups.svg';
import DeleteIcon from '../assets/delete.svg';
import PluginIcon from '../assets/plugins.svg';
import ThemeIcon from '../assets/themes.svg';
import WordpressIcon from '../assets/wordpress.svg';
import ReloadIcon from '../assets/reload.svg';

export default {
  name: 'siteinfo',
  props: ['site'],
  components: {
    EyeIcon,
    MaintananceIcon,
    ServerIcon,
    WriteIcon,
    ViewBackupsIcon,
    OpenAdminIcon,
    BackupsIcon,
    DeleteIcon,
    PluginIcon,
    ThemeIcon,
    ReloadIcon,
    WordpressIcon
  },
  computed: {
    updates() {
      let updates = this.$store.getters.getUpdatesForSite(this.site.siteID);
      let groupedUpdates = _.groupBy(updates, 'type');
      let finalUpdates = {
        plugins: [],
        themes: [],
        core: ''
      };
      if (groupedUpdates.plugins) {
        finalUpdates.plugins = groupedUpdates.plugins;
      }
      if (groupedUpdates.themes) {
        finalUpdates.themes = groupedUpdates.themes;
      }
      if (groupedUpdates.core && groupedUpdates.core.length > 0) {
        finalUpdates.core = groupedUpdates.core[0].name;
      }
      return finalUpdates;
    },
    reloadStats() {
      return this.$store.getters.getReloadStats(this.site.siteID);
    },
    pluginsAndThemes() {
      let pluginsAndThemes = this.$store.getters.getPluginsAndThemesForSite(
        this.site.siteID
      );
      let groupedItems = _.groupBy(pluginsAndThemes, 'type');
      let finalItems = {
        plugins: {
          isActivated: [],
          isInstalled: []
        },
        themes: {
          isActivated: [],
          isInstalled: []
        }
      };
      if (groupedItems.plugins) {
        finalItems.plugins.isInstalled = groupedItems.plugins;
        finalItems.plugins.isActivated = _.filter(groupedItems.plugins, {
          isActivated: true
        });
      }
      if (groupedItems.themes) {
        finalItems.themes.isInstalled = groupedItems.themes;
        finalItems.themes.isActivated = _.filter(groupedItems.themes, {
          isActivated: true
        });
      }
      return finalItems;
    }
  },
  data() {
    return {
      serverURL: window.serverURL,
      showNotesForm: false,
      newNotesText: '',
      newLinksText: '',
      showLinksForm: false
    };
  },
  methods: {
    loadIntialData() {},
    emitAction(action) {
      this.$emit('action', { action: action, site: this.site });
    },
    notesEdit() {
      this.newNotesText = this.site.notes;
      this.showNotesForm = true;
    },
    linksEdit() {
      _.map(this.site.links, link => {
        if (this.newLinksText) {
          return (this.newLinksText = link);
        }
        this.newLinksText = this.newLinksText + ',' + link;
      });
      this.showLinksForm = true;
    },
    saveNotes() {
      let payload = {};
      payload.requiredData = {
        iwpUpdateNotes: {
          siteID: this.site.siteID,
          notes: this.newNotesText
        }
      };
      this.$store.dispatch('sendAction', payload).then(response => {
        
        this.showNotesForm = false;
        this.site.notes = this.newNotesText;
      });
    },
    saveLinks() {
      let payload = {};
      payload.requiredData = {
        iwpUpdateLinks: {
          siteID: this.site.siteID,
          links: this.newLinksText
        }
      };
      this.$store.dispatch('sendAction', payload).then(response => {
        
        this.showLinksForm = false;
        this.site.links = response.data.iwpUpdateLinks.links;
      });
    },
    stopEvent($event){
        $event.stopPropagation();
        $event.preventDefault();
    }
  }
};
</script>

<style scoped lang="scss">
.site-info-container {
  // min-width: 657px;
  //   min-height: 628px;
}
</style>



// WEBPACK FOOTER //
// src/components/SiteInfo.vue